// Shared predicate for the `_`-prefixed property namespace.
//
// Properties whose key starts with `_` are platform-written classification
// stamps (`_render_mode`, `_geo_lat`, `_temporal_min`, ...) — projections
// of schema-authored data, not user data. They are filtered from the
// entity-detail UI, search/filter pickers, and any popup that lists
// entity properties.
//
// See `docs/schemas/case-schema-rules.md` § Property namespaces.

export const isSystemPropertyKey = (key: string): boolean => key.startsWith('_')

// Derived, platform-written properties outside the `_` namespace.
// `name_variants` holds the name search's spellings (transliterations,
// reorderings) written on every Person; never user data, hidden from the
// property panels (ADR-0051).
const DERIVED_PROPERTY_KEYS = new Set(['name_variants'])

/** True for keys no property panel should list: system stamps + derived keys. */
export const isHiddenPropertyKey = (key: string): boolean =>
  isSystemPropertyKey(key) || DERIVED_PROPERTY_KEYS.has(key)
